export const channels = {
  Adwords: 1,
  Bing: 2,
  DoubleClick: 3,
  RightMedia: 4,
  FaceBook: 5,
  Twitter: 6,
  LinkedIn: 7,
  YahooGemini: 8,
  DV360: 9,
  AMS: 10,
  Hotstar: 11,
  Voot: 12,
  Quora: 13,
  Baidu: 14,
  Amadeus: 15,
  AppsFlyer: 16,
  ZohoCRM: 17,
  GoogleAnalytics: 18,
  Magento: 19,
  MicrosoftDynamics: 20,
  Mixpanel: 21,
  Omniture: 22,
  Salesforce: 23,
  Shopify: 24,
  AppNexus: 25,
  MediaMath: 26,
  OutBrain: 27,
  Pinterest: 28,
  Naver: 29,
  Snapchat: 30,
  AdRoll: 31,
  Eskimi: 32,
  ASA: 34,
  TikTok: 35,
  PowerBi: 36,
  TheTradeDesk: 37,
  GMB: 38,
  LeadX: 39,
  Reddit: 40,
  Instacart: 41,
  Moloco: 45,
  Criteo: 47,
  SA360: 48
}

export const channeInfo = {
  [channels.FaceBook]: {
    name: 'Facebook',
    icon: 'mdi-facebook'
  },
  [channels.GoogleAnalytics]: {
    name: 'Google',
    icon: 'mdi-google'
  }
}
